import { useEffect, useState } from 'react';
import { Button } from 'antd';
import AlertPopup from '../AlertPopup/AlertPopup';
import dayjs from 'dayjs';
import { DMS_TYPE, HYPHEN } from '../../utilities/constants';
import { useSocket } from '../../context/SocketContext';
import { useNavigate } from 'react-router-dom';

const DriverDrowsinessPopup = () => {
  const [open, setOpen] = useState(false);
  const { dmsData } = useSocket();
  const navigate = useNavigate();

  useEffect(() => {
    if (dmsData?.anomaly_type === DMS_TYPE.DROWSINESS) {
      setOpen(true);
    }
  }, [dmsData]);

  const handleClose = () => setOpen(false);

  const formatDate = timestamp => {
    if (timestamp) {
      return dayjs(timestamp).format('MMM DD, YYYY, hh:mm A');
    } else {
      return HYPHEN;
    }
  };

  const getAlertTitle = () => {
    if (dmsData?.anomaly_type === DMS_TYPE.DROWSINESS)
      return 'Driver Drowsiness alert!';
    if (dmsData?.anomaly_type === DMS_TYPE.DISTRACTION)
      return 'Driver Distraction alert!';
    return 'Driver Distraction/Drowsiness alert';
  };

  const handleGoToIssueClick = () => {
    navigate('/driver-monitoring-system');
    handleClose();
  };

  const footerButtons = [
    <Button
      key="send"
      type="primary"
      htmlType="submit"
      onClick={handleGoToIssueClick}
    >
      Go to issue
    </Button>,
    <Button key="cancel" onClick={handleClose}>
      Cancel
    </Button>,
  ];

  const additionalFields = [
    {
      label: 'Timestamp',
      value: formatDate(dmsData?.event_timestamp),
    },
    {
      label: 'Speed',
      value:
        dmsData?.speed === 999
          ? 'Speed service not available'
          : dmsData?.speed !== undefined && dmsData?.speed !== null
            ? `${Math.round(dmsData.speed)} km/h`
            : HYPHEN,
    },
  ];

  return (
    <AlertPopup
      open={open}
      onClose={handleClose}
      title={getAlertTitle()}
      data={dmsData}
      additionalFields={additionalFields}
      footerButtons={footerButtons}
    />
  );
};

export default DriverDrowsinessPopup;
